import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';

import TryForFreeImage from '@/images/placeholders/try-phishing.svg';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  height: auto;
  width: 100%;
  background-color: var(--beige-main);
  border-radius: var(--medium-border-radius);
  padding: var(--big-padding);

  p {
    text-align: center;
    line-height: var(--medium-line-height);
    font-weight: 500;
  }

  img {
    height: auto;
    width: 100%;
    margin-bottom: var(--default-padding);
  }

  .p-button {
    padding-inline: var(--big-padding);
    font-size: var(--large-font-size);
  }
`;

export const TryForFreePhishing: React.FC<{ isLoading: boolean }> = ({
  isLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledContainer direction="column" flex="1">
      {isLoading ? (
        <ProgressSpinner />
      ) : (
        <>
          <img
            style={{ maxHeight: '240px' }}
            src={TryForFreeImage}
            alt={t('campaign.tryForFree')}
          />
          <p>{t('campaign.tryForFree.text')}</p>
          <FlexContainer gap={8}>
            <AppButton
              label={t('campaigns.catalogue.title')}
              severity="secondary"
              type="outlined"
              onClick={() =>
                navigate(
                  RedirectPaths[RedirectPathsEnum.CAMPAIGNS_CATALOGUE_V2](),
                )
              }
            />
            <AppButton
              label={t('campaign.tryForFree')}
              onClick={() =>
                navigate(RedirectPaths[RedirectPathsEnum.HUBSPOT_BOOKING](), {
                  state: { from: location.pathname },
                })
              }
            />
          </FlexContainer>
        </>
      )}
    </StyledContainer>
  );
};
